import React, { useEffect } from 'react';
import { DashboardLayout } from '../components/UI/Layout/DashboardLayout';
import CampaignDetailComponent from 'components/EmailMarketing/Detail/CampaignDetailComponent';

export const EmailCampaignDetail: React.FC = () => {
    useEffect(() => {
        document.title = 'Campaign report - Organizations';
    }, []);

    return (
        <DashboardLayout>
            <CampaignDetailComponent />
        </DashboardLayout>
    );
};

export default EmailCampaignDetail;
